<script>
  import { createEventDispatcher } from 'svelte'
  import DataTable from './SimpleDataTable.svelte'
  import DataTableExpansion from './DataTableExpansion.svelte'
  import Loader from '../Loader/Loader.svelte'
  import { cssPrefix } from '../helper-classes.js'

  export let data = []
  export let key = 'id'
  export let multipleExpansions = false
  export let hasExpansions = null
  export let id = null
  export let selectable = false
  export let header = true
  export let fullWidth = null
  export let stickyHead = false
  export let scrollable = false
  export let variant = null
  export let showEmpty = true
  export let loading = null
  export let mobile = null
  export let align = null
  export let valign = null

  const dispatch = createEventDispatcher()

  let normalizedData = []
  let selectedItems = []
  let expandedItems = []
  let table

  const onChange = ({ detail }) => {
    dispatch('change', detail)

    selectedItems = detail.selected.map(item => item[key])
  }

  const onDataChange = data => {
    if (data.some(item => !item || item[key] === undefined || item[key] === null)) {
      console.debug(
        '[DS:DataTableExtended] Data malformed: please check that the provided key exists in every item of your data'
      )
    }

    updateSelectedItemsFromData(data)

    normalizedData = data.map(item => ({
      __id: item[key],
      ...item
    }))
  }

  const toggleExpansion = row => {
    expandedItems = expandedItems.includes(row[key])
      ? expandedItems.filter(item => item !== row[key])
      : [...(multipleExpansions ? expandedItems : []), row[key]]
  }

  const updateSelectedItemsFromData = data => {
    const newSelectedItems = []

    for (const keyValue of selectedItems) {
      const item = data.find(item => item[key] === keyValue)

      if (item && item.selectable !== false) {
        item.selected = true
        newSelectedItems.push(keyValue)
      }
    }

    selectedItems = newSelectedItems
  }

  $: onDataChange(data)

  export const getSelected = () => (table ? table.getSelected() : [])
</script>

<DataTable
  bind:this={table}
  data={normalizedData}
  {...$$restProps}
  let:row
  let:index
  on:change={onChange}
  on:toggleExpansion={row => toggleExpansion(row.detail)}
  {hasExpansions}
  {id}
  {key}
  {selectable}
  {header}
  {fullWidth}
  {stickyHead}
  {scrollable}
  {variant}
  {showEmpty}
  {loading}
  {mobile}
  {align}
  {valign}
>
  <slot {index} {row} />
  <slot name="empty" slot="empty">
    <div class={`${cssPrefix}message`} style="text-align: center">There is no data available to be shown</div>
  </slot>
  <slot name="loader" slot="loader">
    <Loader class="mx-auto size-medium" />
  </slot>

  <DataTableExpansion slot="expansion" let:row let:index>
    {#if expandedItems.includes(row[key])}
      <slot name="expansionContent" {row} {index} />
    {/if}
  </DataTableExpansion>
</DataTable>
